import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TranslocoService } from "@ngneat/transloco";
import { BlogClass } from "app/shared/blogs";
import { Observable, Subscription } from "rxjs";
import { map } from "rxjs/operators";
import { Title } from "@angular/platform-browser";

@Component({
  selector: "app-by-bag-product",
  templateUrl: "./by-bag-product.component.html",
  styleUrls: ["./by-bag-product.component.scss"],
})
export class ByBagProductComponent implements OnInit, OnDestroy {
  machines$: Observable<BlogClass[]>;
  activeLang: string = "EN";
  private langChangesSubscription: Subscription;
  productName: string = "";

  constructor(
    private route: ActivatedRoute,
    private _translocoService: TranslocoService,
    private titleService: Title
  ) {}

  ngOnInit(): void {
    // 1) جلب البيانات من الـresolver
    this.machines$ = this.route.data.pipe(
      map((data: any) => data.searchMachines)
    );

    // 2) قراءة اللغة الحالية
    this.getActiveLang();

    // 3) قراءة اسم المنتج من الكويري بارام
    this.route.queryParamMap.subscribe((params) => {
      this.productName = params.get("name") || "";
      if (this.productName) {
        this.titleService.setTitle(this.productName); // تعيينه كعنوان للصفحة
      }
    });
  }

  getActiveLang() {
    this.langChangesSubscription =
      this._translocoService.langChanges$.subscribe((activeLang) => {
        this.activeLang = activeLang;
      });
  }

  ngOnDestroy() {
    if (this.langChangesSubscription) {
      this.langChangesSubscription.unsubscribe();
    }
  }
}
